export class GetEligibilityLogsBo {
    employeeId: string ="00000000-0000-0000-0000-000000000000";
    clientId: string ="00000000-0000-0000-0000-000000000000";
    fromDate: string | null;
    toDate: string | null;
    searchColumn: string = "companyName";
    searchText: string = "";
    agencyID: string ="00000000-0000-0000-0000-000000000000";
    currentpageno: number = 1;
    pageitem: number = 10;
    orderColumn: string = "companyName";
    orderType: string = "asc";
    type: string = "string";
    field: string = "companyName";
    value: string = "";
    matchCase: boolean = false;
    operator: string = "startswith";
    locationID: string ="00000000-0000-0000-0000-000000000000";
    startDate: string | null;
    endDate: string | null;
    edi_Status: string;
    transaction_Status=null;
}

export class GetEligibility271 {
    employeeId: string ="00000000-0000-0000-0000-000000000000";
    clientId: string ="00000000-0000-0000-0000-000000000000";
    fromDate: string | null;
    toDate: string | null;
    searchColumn: string = "companyName";
    searchText: string = "";
    agencyID: string ="00000000-0000-0000-0000-000000000000";
    currentpageno: number = 1;
    pageitem: number = 10;
    orderColumn: string = "companyName";
    orderType: string = "asc";
    type: string = "string";
    field: string = "companyName";
    value: string = "";
    matchCase: boolean = false;
    operator: string = "startswith";
    locationID: string ="00000000-0000-0000-0000-000000000000";
    startDate: string | null;
    endDate: string | null;
    edi_Status: string;
    transaction_Status=null;
}



export class FilterLogsBo
{
FromDate:string=null;
ToDate:string=null;
edi_Status:string=null;
transaction_Status=null;
}

export class ApplyFilter271
{
FromDate:string=null;
ToDate:string=null;
edi_Status:string=null
transaction_Status=null;

}


